export const exterior_view05ImageOptions = {
  angle: 'exterior_view05',
  staticOptions: {
    HullColour: 1,
    BowSprit: 1,
    HullTreatment: 1,
    Deck: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    SolarPanels: 1,
    DavidsRib: 1,
    RemovableGangway: 1,
    MastAndBoom: 1,
    SprayHood: 1,
    BoomCover: 1,
    Boom: 1
  },
  mattes: [
    {
      option: 'HullColour',
      dependency: null
    },
    {
      option: 'HullTreatment',
      dependency: null
    },
    {
      option: 'Deck',
      dependency: 'Wheel'
    },
    {
      option: 'TeakOnSideDecks',
      dependency: 'Deck'
    },
    {
      option: 'DavidsRib',
      dependency: null
    },
    {
      option: 'RemovableGangway',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/Xc47/views/exterior_view05.js